import Repository from '@/api/Repository'

const resource = '/ftp'

export default {
  ingest(config = {}) {
    return Repository.get(`${resource}/ingest`, config)
  },
  credentials(config = {}) {
    return Repository.get(`${resource}/credentials`, config)
  },
}
